import { BaseService } from "./base.service";
import { api } from "@/lib/api";
import { ApiError, ApiResponse } from "@/interfaces/api.interface";
import { store } from "@/store/store";
import { hideLoader, showLoader } from "@/store/slices/loaderSlice";

export class UserService extends BaseService {
  constructor() {
    super("User");
  }

  async toggleProjectMembership(
    id: string,
    projectId: string,
    isActive: boolean
  ): Promise<ApiResponse<void>> {
    try {
      store.dispatch(showLoader());
      const res: any = await api.patch(
        `${process.env.REACT_APP_BASE_URL}/api/User/${id}/project-membership`,
        null,
        { params: { projectId, isActive } }
      );
      return { data: res.data, error: null };
    } catch (error) {
      return { data: null, error: error as ApiError };
    } finally {
      store.dispatch(hideLoader());
    }
  }
}

export const userSvc = new UserService();
